import { FormStates } from '@fundamental-ngx/cdk/forms';

export class KeyValueValidatorModel {
    state: FormStates;
    message: string;
    regex: string;

    constructor(init?: Partial<KeyValueValidatorModel>) {
        Object.assign(this, init);
    }
}
